var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRed5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.002 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB1F26",
    d: "M16.75 11.401V4.443h7.246V0H0v12.538h7.175v6.96H0V24h23.996V11.401z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed5);
export default __webpack_public_path__ + "static/media/red5.7737435093750940b345beab4f0e9c26.svg";
export { ForwardRef as ReactComponent };